import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Card, Tag, Badge, Empty, Progress } from 'antd';
import { useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie'
import { Row, Col } from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { getBizID, /* getStyle, setStepRedux  */ } from '../../../../libs/todoSlice';
import { setHistoryDetail,/*  setDataDefault, */ getHistoryDefault, setHistoryDefault, getTrickerExcel } from '../../../../libs/historySlice';
import { /* getTricker, */ setManageMemberStep } from '../../../../libs/sideBarSlice';
import LoadingComponent from '../../../../lib/LoadingComponent';
import axios from 'axios';
import { w3cwebsocket as W3CWebSocket } from 'websocket'
import * as XLSX from 'xlsx'


const AddMophCaregiverHistory = () => {


    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const business_id = useSelector(getBizID)
    const [cookie] = useCookies(['account'])
    const params = useParams()
    const [all_history, setAllHistory] = useState(0)
    const [success_history, setSuccessHistory] = useState(0)
    const [fail_history, setFailHistory] = useState(0)
    const [loading, setLoading] = useState(false)
    const biz_id = useSelector(getBizID)
    const [show, setShow] = useState('All')
    // const [ step, setStep] = useState('')

    const dataDefault = useSelector(getHistoryDefault)
    const trigger = useSelector(getTrickerExcel)
    const setDataDefault = (action) => {
        dispatch(setHistoryDefault({
            historyDefault: action
        }))
    }

    const navigate = useNavigate()
    useEffect(() => {
        

        if (business_id) {
            getExcel()
        }
    }, [business_id, trigger])

    useEffect(() => {
        const client = new W3CWebSocket(process.env.REACT_APP_BACKEND_WS_URL);

        client.onmessage = ({ data }) => {

            const newSocket = JSON.parse(data)

            if (newSocket.channel === biz_id && newSocket.event === "moph-care-giver-status-event") {
                setData((prevData) => {
                    return prevData.map((item) => {
                        if (item.excel._id === newSocket._id) {
                            let newData = {
                                ...item,
                                total: newSocket.total,
                                progress: newSocket.progress,
                                fail: newSocket.fail,
                                success: newSocket.success,
                            };
                            if (newSocket.progress !== newSocket.total) {
                                newData.loading = true
                                newData.status = null;
                            }
                            else if (newSocket.progress === newSocket.total) {
                                newData.loading = false;
                                if (newSocket.fail > 0) {
                                    newData.status = false;
                                }
                                else {
                                    newData.status = true;
                                }
                            }
                            return newData
                        }
                        return item;
                    });
                });
            }

        };
    }, []);


    const getExcel = async () => {
        setLoading(true)
        await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel?business_id=${business_id}`,
        }).then(({ data, status }) => {
            if (data.data.excel) {
                const havePreRegis = data.data.excel.filter(items => items.importHistories.length > 0)
                const TeacherExcel = havePreRegis.filter(item => {
                    return item.importHistories.some(history => history.objective.includes('moph-caregiver-pre-register'));
                });
                let all = TeacherExcel.length
                let success = TeacherExcel.filter(item => {
                    let lastIndex = item.importHistories.length
                    return item.importHistories[lastIndex - 1].fail === "0"
                })
                let fail = TeacherExcel.filter(item => {
                    let lastIndex = item.importHistories.length
                    return item.importHistories[lastIndex - 1].fail > 0
                })
                setAllHistory(all)
                setSuccessHistory(success.length)
                setFailHistory(fail.length)
                let prepareData = TeacherExcel.map((excel, index) => {
                    let create_date = new Date(excel.createdAt)
                    let completed = excel.importHistories[excel.importHistories.length - 1].total === excel.importHistories[excel.importHistories.length - 1].success
                    let create_by = excel.importHistories[excel.importHistories.length - 1].createdBy

                    return {
                        index: index + 1,
                        operation_date: `${create_date?.getDate()}/${create_date?.getMonth() + 1}/${create_date?.getFullYear()}`,
                        count_member: excel.importHistories[excel.importHistories.length - 1].total,
                        objective: excel.importHistories[excel.importHistories.length - 1].objective.join(', '),
                        Operator: `${create_by?.account_title_th} ${create_by?.first_name_th} ${create_by?.last_name_th}`,
                        status: completed,
                        excel: excel
                    }
                })
                setData(prepareData)
                setDataDefault(prepareData)
            }
            setLoading(false)
        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
        })
    }

    // start select row
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    // const [stateBtnAgain, setStateBtnAgain] = useState([]);
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // setStateBtnAgain(selectedRows)
        },
        getCheckboxProps: (record) => ({
            // Column configuration not to be checked
            index: record.index,
        }),
    };
    // end select row

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };

    //csearch 
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
    const columns = [
        {
            title: 'ลำดับ',
            width: 15,
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                return a.index - b.index
            }
        },
        {
            title: 'สถานะล่าสุด',
            dataIndex: 'status',
            width: 30,
            render: (_, value) => {
                return (
                    <>
                        {value.loading === true ?
                            (<Progress
                                percent={parseInt((value.progress / value.total) * 100)} status="active" strokeColor='#53BE35'
                            />
                            )
                            :
                            value.status === true ?
                                <Tag color="success">
                                    <Badge status="success" /> เพิ่มครบแล้ว
                                </Tag>
                                :
                                <Tag color="warning">
                                    <Badge status="warning" /> ยังเพิ่มไม่ครบ
                                </Tag>
                        }
                    </>
                )
            }
        },
        {
            title: 'วันที่ดำเนินการ',
            width: 30,
            dataIndex: 'operation_date',

            // fixed: 'left',
            // ...getColumnSearchProps('operation_date'),
        },
        {
            title: (<>จำนวนรายชื่อ <br />(รายการ)</>),
            width: 30,
            dataIndex: 'count_member',

            // fixed: 'left',
            // ...getColumnSearchProps('count_member'),
        },
        {
            title: 'ผู้ดำเนินการ',
            dataIndex: 'Operator',
            width: 40,

            // ...getColumnSearchProps('Operator'),
        },
        {
            title: 'ประเภท',
            dataIndex: 'objective',
            width: 40,

            // ...getColumnSearchProps('Operator'),
        },
        {
            title: 'Download Excel',
            // dataIndex: 'status',
            width: 40,
            render: (_, value) => {
                const keyNote = {
                    'The first name eng format is invalid.': 'Format ชื่อภาษาอังกฤษไม่ถูกต้อง',
                    'The first name th format is invalid.': 'Format ชื่อภาษาไทยไม่ถูกต้อง',
                    'The last name eng format is invalid.': 'Format นามสกุลภาษาอังกฤษไม่ถูกต้อง',
                    'The last name th format is invalid.': 'Format นามสกุลภาษาไทยไม่ถูกต้อง',
                    'The selected account title th is invalid.': 'คำนำหน้าไม่ถูกต้อง',

                    'account_title_eng Invalid value': 'คำนำหน้าภาษาอังกฤษไม่ถูกต้อง',
                    'account_title_th Invalid value': 'คำนำหน้าภาษาไทยไม่ถูกต้อง',
                    'email Invalid value': 'Email ไม่ถูกต้อง',
                    'mobile_no Invalid value': 'เบอร์มือถือไม่ถูกต้อง',
                    'first_name_eng Invalid value': 'ชื่อภาษาอังกฤษไม่ถูกต้อง',
                    'first_name_th Invalid value': 'ชื่อภาษาไทยไม่ถูกต้อง',
                    'last_name_eng Invalid value': 'นามสกุลภาษาอังกฤษไม่ถูกต้อง',
                    'last_name_th Invalid value': 'นามสกุลภาษาไทยไม่ถูกต้อง',
                    'id_card_num Invalid value': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
                    'special_title_th Invalid value': 'คำนำหน้านามภาษาไทยไม่ถูกต้อง',
                    'special_title_eng Invalid value': 'คำนำหน้านามภาษาอังกฤษไม่ถูกต้อง',
                    'position Invalid value': 'ตำแหน่งไม่ถูกต้อง',
                    'employee_id Invalid value': 'เลขประจำตัวบุคลากรทางการแพทย์ไม่ถูกต้อง',
                    'The mobile no may not be greater than 10 characters.': 'หมายเลขโทรศัพท์มือถือต้องมีความยาวไม่เกิน 10 ตัวอักษร',
                    'The username format is invalid.': 'เกิดข้อผิดพลาดในการตั้ง username',
                    'Thai Email Cannot Created': 'เกิดข้อผิดพลาดในการสร้างอีเมล',
                    'id card duplicated': 'เลขบัตรประชาชนซ้ำในระบบ',
                    'student_id Invalid value': 'เลขประจำตัว นักเรียน/บุคลากร ไม่ถูกต้อง',
                    "zipcode can't match": 'รหัสไปรษณีย์ไม่ถูกต้อง',
                    'title_en is not match': 'คำนำหน้าภาษาอังกฤษไม่สอดคล้องกัน',
                    'title_th is not match': 'คำนำหน้าภาษาไทยไม่สอดคล้องกัน',
                    'status Invalid value': 'สถานะไม่ถูกต้อง',
                    'start_year Invalid value': 'วันที่เริ่มต้นไม่ถูกต้อง',
                    'end_year Invalid value': 'วันที่สิ้นสุดไม่ถูกต้อง',
                    'This account_id has not been username.': 'มี account อยู่แล้ว แต่ยังไม่ตั้ง username กรุณาตั้ง username แล้วอัพโหลดอีกครั้ง',
                    'tel Invalid value': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
                    'cid is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
                    'district Invalid value': 'อำเภอไม่ถูกต้อง',
                    'province Invalid value': 'จังหวัดไม่ถูกต้อง',
                    'sub_district Invalid value': 'ตำบลไม่ถูกต้อง',
                    "zipcode Cast to Number failed for value \NaN\(type number)at path\zipcode\for model\zipcodes": 'รหัสไปรษณีย์ไม่ถูกต้อง',
                    'start year Invalid value': 'วันที่เริ่มต้นการศึกษาไม่ถูกต้อง',
                    'student_id is duplicated': 'รหัสนักศึกษา/บุคลากร ซ้ำ',
                    'zipcode Cast to Number failed for value \NaN\(type number)at path\zipcode\for model\zipcodes': 'รหัสไปรษณีย์ไม่ถูกต้อง',
                    'start year Invalid value': 'วันที่เริ่มต้นการศึกษาไม่ถูกต้อง',
                    'student_id is duplicated': 'รหัสนักศึกษา/บุคลากร มีซ้ำในระบบ',
                    'name_th Invalid value': 'ชื่อ (ภาษาไทย) ไม่ถูกต้อง',
                    'title_th Invalid value': 'คำนำหน้า (ภาษาไทย) ไม่ถูกต้อง',
                    'birth_date Invalid value': 'วันเกิด ไม่ถูกต้อง',
                    'name_eng Invalid value': 'ชื่อ (ภาษาอังกฤษ) ไม่ถูกต้อง',
                    'title_en Invalid value': 'คำนำหน้า (ภาษาอังกฤษ) ไม่ถูกต้อง',
                    'Error': 'ระบบมีปัญหา',
                    'id_card_num is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
                    'surname_eng Invalid value': 'นามสกุล (ภาษาอังกฤษ) ไม่ถูกต้อง',
                    'surname_th Invalid value': 'นามสกุล (ภาษาไทย) ไม่ถูกต้อง',
                    "cid Cannot read properties of undefined (reading 'length')": 'ความยาวของหมายเลขบัตรประชาชนไม่ถูกต้อง',
                    "The username must be at least 6 characters.": 'ความยาวของชื่อภาษาอังกฤษไม่เพียงพอต่อการ generate username',

                }
                function translateMessage(message, keyNote) {
                    if (typeof message === 'string') {
                        // If message is a string, try to translate it
                        return keyNote[message] || message;
                    } else if (Array.isArray(message)) {
                        // If message is an array, recursively translate its elements
                        return message.map(item => translateMessage(item, keyNote));
                    } else if (typeof message === 'object') {
                        // If message is an object, recursively translate its properties
                        const translatedMessage = {};
                        for (const key in message) {
                            translatedMessage[key] = translateMessage(message[key], keyNote);
                        }
                        return translatedMessage;
                    } else {
                        // If the message is of an unexpected type, return it as-is
                        return message;
                    }
                }
                return (
                    <>
                        <Button onClick={
                            () => {
                                if (
                                    Array.isArray(value.excel.importHistories) &&
                                    value.excel.importHistories.length > 0
                                ) {
                                    const wb = XLSX.utils.book_new();

                                    // Create a function to convert detail data into a sheet
                                    function createSheet(detail, sheetName) {
                                        const dataArray = [];

                                        if (Array.isArray(detail) && detail.length > 0) {
                                            // Add headers to the dataArray
                                            const headers = [
                                                ...Object.keys(detail[0].request),
                                                'response.message',
                                                'response.data',
                                                'response.error',
                                            ];
                                            dataArray.push(headers);

                                            // Loop through the data objects and extract the values
                                            detail.forEach(item => {
                                                let messageValue = translateMessage(item.response.message, keyNote);

                                                // Convert the translated messageValue to a string if it's an object
                                                if (typeof messageValue === 'object') {
                                                    messageValue = JSON.stringify(messageValue);
                                                }

                                                const row = [
                                                    ...headers.slice(0, -3).map(header => item.request[header]), // Exclude response fields for request
                                                    messageValue, // Include response.message
                                                    item.response.data,
                                                    item.response.error,
                                                ];
                                                dataArray.push(row);
                                            });

                                            const ws = XLSX.utils.aoa_to_sheet(dataArray);
                                            XLSX.utils.book_append_sheet(wb, ws, sheetName);
                                        }
                                    }

                                    // Export failDetail to Sheet2
                                    createSheet(value.excel.importHistories[0].failDetail, 'FailDetail');

                                    // Export successDetail to Sheet1
                                    if (value.excel.importHistories[0].successDetail) {
                                        createSheet(value.excel.importHistories[0].successDetail, 'SuccessDetail');
                                    }

                                    if (wb.SheetNames.length > 0) {
                                        XLSX.writeFile(wb, 'data.xlsx');
                                    } else {
                                        console.log('No data to export.');
                                    }
                                } else {
                                    console.log('Data is missing or has an unexpected structure.');
                                }
                            }
                        }>
                            Download
                        </Button>
                    </>
                )
            }
        },
        {
            title: 'จัดการ',
            dataIndex: 'manage',
            width: 30,
            render: (_, record, index) => {
                return (
                    <>
                        <Button
                            disabled={record.loading === true}
                            onClick={() => {
                                dispatch(setManageMemberStep({
                                    manageMemberStep: 'history_detail'
                                }))
                                dispatch(setHistoryDetail({
                                    historydetail: record.excel
                                }))
                            }}
                            style={{ backgroundColor: '#F3F5FA', color: '#3776E9' }}>
                            ดูรายละเอียด
                        </Button>
                    </>
                )
            },
        },
    ];

    return (
        <>
            {
                loading ?
                    <LoadingComponent />
                    :
                    <>
                        <Row>
                            <Col xxl={3} xl={4} lg={4} md={12} sm={12} xs={12}>
                                <Card
                                    style={{
                                        width: '100%',
                                        borderRadius: '16px',
                                        marginRight: '20px',
                                        marginBottom: '10px',
                                        cursor: 'pointer',
                                        backgroundImage: show === 'All' ? 'linear-gradient( transparent -10%, #3776E9 150%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        setData(dataDefault)
                                        setShow('All')
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <FormatListBulletedIcon style={{
                                                backgroundColor: '#3776E9',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#fff',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#3776E9',
                                                fontWeight: '700'
                                            }}>
                                                {all_history}
                                            </span>
                                            <br />
                                            รายการทั้งหมด
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xxl={3} xl={4} lg={4} md={12} sm={12} xs={12}>
                                <Card
                                    style={{
                                        width: '100%',
                                        borderRadius: '16px',
                                        marginBottom: '10px',
                                        cursor: 'pointer',
                                        backgroundImage: show === 'Success' ? 'linear-gradient( transparent -10%, #53BE35 150%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        let members = [...dataDefault]
                                        setData(members.filter(member => member.status === true))
                                        setShow('Success')
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <CheckIcon style={{
                                                backgroundColor: '#F3F5FA',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#53BE35',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#53BE35',
                                                fontWeight: '700'
                                            }}>
                                                {success_history}
                                            </span>
                                            <br />
                                            รายการที่สำเร็จ
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xxl={3} xl={4} lg={4} md={12} sm={12} xs={12}>
                                <Card
                                    style={{
                                        width: '100%',
                                        borderRadius: '16px',
                                        marginBottom: '10px',
                                        cursor: 'pointer',
                                        backgroundImage: show === 'Fail' ? 'linear-gradient( transparent -10%, #F37959 150%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        let members = [...dataDefault]
                                        setData(members.filter(member => member.status === false))
                                        setShow('Fail')
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <CloseIcon style={{
                                                backgroundColor: '#F3F5FA',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#F37959',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#F37959',
                                                fontWeight: '700'
                                            }}>
                                                {fail_history}
                                            </span>
                                            <br />
                                            รายการที่ไม่สำเร็จ
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                        <Table
                            columns={columns}
                            dataSource={data}
                            scroll={{
                                x: 1400,
                                y: 400,
                            }}
                            locale={customLocale}
                            pagination={{
                                page: page,
                                pageSize: pageSize,
                                onChange: (page, pageSize) => {
                                    setPage(page)
                                    setPageSize(pageSize)
                                }
                            }}
                        />
                    </>
            }
        </>
    );
}
export default AddMophCaregiverHistory;